import React from "react";
import { connect } from "react-redux";
import FilmalityCircularProgress from "../../../shared/filmality-circular-progress";
import Character from "./character";
import Actor from "./actor";
import Errors from "../../../shared/errors";
import HelpText from "../../../shared/help-text";
import {
  OnboardingStep1ClassName,
  OnboardingStep2ClassName,
  OnboardingStep3ClassName,
  OnboardingStep4ClassName
} from "./ducks/reducer";
import Onboarding from '../../../shared/onboarding/onboarding';
import './character-overview.scss';
import FilmanizeRadio from "../../../shared/filmanize-radio";
import { CHARACTER_OVERVIEW_ORDER_NAME, CHARACTER_OVERVIEW_ORDER_NUMBER_OF_SCENES } from "./ducks/actions";

function Overview(props) {
  const {
    overview,
    filmId,
    charactersAssignedPercentage,
    assignActor,
    unassignActor,
    aliasCharacter,
    unaliasCharacter,
    errors,
    warnings,
    characterOrderBy,
    charactersOnboardingSteps,
    orderCharactersBy
  } = props;

  const readOnly = overview.readOnly;

  const onOrderCharacterByChange = (order: string) => {
    orderCharactersBy(order);
  }

  return (
    <div>
      <div className="columns">
        <div
          className={`${OnboardingStep1ClassName} circular-progress column is-one-quarter`}>
          <FilmalityCircularProgress
            percentage={overview.completedCharactersPercentage}
            title="Completed Characters"
          />
        </div>
        <div className="circular-progress column is-one-quarter">
          <FilmalityCircularProgress
            percentage={charactersAssignedPercentage}
            title="Characters Assigned"
          />
        </div>
      </div>
      {/* <RenderHelpText /> */}
      {errors && <Errors errors={errors} />}
      {warnings && <Errors errors={warnings} isWarning={true} />}
      <div className="buttons">
        <FilmanizeRadio text="Order by Name" value={CHARACTER_OVERVIEW_ORDER_NAME} checked={characterOrderBy === CHARACTER_OVERVIEW_ORDER_NAME} onChange={onOrderCharacterByChange} />
        <FilmanizeRadio text="Order by Number of Scenes" value={CHARACTER_OVERVIEW_ORDER_NUMBER_OF_SCENES} checked={characterOrderBy === CHARACTER_OVERVIEW_ORDER_NUMBER_OF_SCENES} onChange={onOrderCharacterByChange} />
      </div>
      <div className="columns">
        <div className="column">
          <table className={`${OnboardingStep3ClassName} table`}>
            <thead>
              <tr>
                <th>Character Name</th>
                <th>Scenes</th>
                <th>Actor Name</th>
                <th>Mandy Url</th>
                <th>Starnow Url</th>
              </tr>
            </thead>
            <tbody>
              {(overview.characters || []).map((character, index) => {
                return (
                  <Character
                    key={index}
                    index={index}
                    character={character}
                    filmId={filmId}
                    assignActor={assignActor}
                    unassignActor={unassignActor}
                    aliasCharacter={aliasCharacter}
                    unaliasCharacter={unaliasCharacter}
                    readOnly={readOnly}
                    totalScenes={overview.totalScenes}
                    canAccessActors={overview.canAccessActors}></Character>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="column is-narrow">{!readOnly && <div className="sticky">
          <table className={`${OnboardingStep4ClassName} table character-overview-actors-table`}>
            <thead>
              <tr>
                <th>Actor</th>
              </tr>
            </thead>
            <tbody>
              {(overview.actors || []).map((actor, index) => {
                return (
                  <Actor
                    key={index}
                    actor={actor}
                    index={index}
                    filmId={filmId}
                    readOnly={readOnly}></Actor>
                );
              })}
            </tbody>
          </table>
        </div>}</div>
      </div>

      <Onboarding onboardingSteps={charactersOnboardingSteps} section="Characters" />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    charactersOnboardingSteps:
      state.charactersState.overviewState.charactersOnboardingSteps
  };
}

export default connect(mapStateToProps, {
})(Overview);
